import { request } from '@/api/service'

/*
 *
 */
export function crmContactsQuery(data) {
   return request({
      url: 'crm/4front/contacts/query/',
      method: 'POST',
      data: data,
   })
}

/*
 *
 */
export function relFriendsContactsQuery(data) {
   return request({
      url: 'crm/4front/rel_friends_contacts/query/',
      method: 'POST',
      data: data,
   })
}

/*
 *
 */
export function callLogStaticRelQuery(data) {
   return request({
      url: 'tc_api/4front/tccc/call_log_static_rel/query/',
      method: 'POST',
      data: data,
   })
}

/**
 * 我的联系人-查询
 */
export function rel_contacts_users_favourites_query(obj) {
   return request({
      url: 'crm/4front/rel_contacts_users_favourites/query/',
      method: 'post',
      data: obj,
   })
}

/**
 * 座席-查询特定用户拥有座席
 */
export function seats_resp_groups_query(obj) {
   return request({
      url: '/tc_api/4front/tccc/seats_resp_groups/query/',
      method: 'post',
      data: obj,
   })
}

/**
 * 根据用户ID查询绑定的坐席
 */
export function getSeatsByUserId(obj) {
   return request({
      url: '/tc_api/4front/tccc/seats/get_by_user_id/',
      method: 'post',
      data: obj,
   })
}

/**
 * 座席-设置默认座席
 */
export function resp_groups_multi_modify(obj) {
   return request({
      url: '/tc_api/4front/tccc/resp_groups/multi/modify/',
      method: 'post',
      data: obj,
   })
}

/**
 * 切换分机or手机接听
 */
export function switch_bind_seat(obj) {
   return request({
      url: '/tc_api/4front/tccc/extension/switch/bind/seat/',
      method: 'post',
      data: obj,
   })
}

/**
 * 查询分机or手机接听
 */
export function rel_exts_users_query(obj) {
   return request({
      url: '/tc_api/4front/tccc/rel_exts_users/query/',
      method: 'post',
      data: obj,
   })
}

/**
 * 切换用户拨打方式 h5拨打 or spiSdk拨打
 */
export function universal_cfg_create(obj) {
   return request({
      url: '/cfg_mgr/4front/cfg/universal/create',
      method: 'put',
      data: obj,
   })
}

/**
 * 查询用户拨打方式 h5拨打 or spiSdk拨打
 */
export function universal_cfg_query(obj) {
   return request({
      url: '/cfg_mgr/4front/cfg/universal/query',
      method: 'post',
      data: obj,
   })
}

/**
 * 获取外呼号码列表
 */
export function describe_number(obj) {
   return request({
      url: '/tc_api/tccc/general/describe_number/',
      method: 'post',
      data: obj,
   })
}

/**
 * 号码管理相关接口
 */

/**
 * 查询号码列表
 */
export function getNumberList(obj) {
   return request({
      url: '/tc_api/4front/number/list/query/',
      method: 'post',
      data: obj,
   })
}

/**
 * 创建/更新号码
 */
export function updateNumber(obj) {
   return request({
      url: '/tc_api/4front/number/personal/update/',
      method: 'post',
      data: obj,
   })
}

/**
 * 删除号码
 */
export function deleteNumber(obj) {
   return request({
      url: '/tc_api/4front/number/personal/delete/',
      method: 'delete',
      data: obj,
   })
}

/**
 * 添加默认号码
 */
export function addDefaultNumber(obj) {
   return request({
      url: '/tc_api/4front/number/personal/default/add/',
      method: 'post',
      data: obj,
   })
}

/**
 * 取消默认号码
 */
export function removeDefaultNumber(obj) {
   return request({
      url: '/tc_api/4front/number/personal/default/delete/',
      method: 'post',
      data: obj,
   })
}

/**
 * 激活号码
 */
export function enableNumber(obj) {
   return request({
      url: '/tc_api/4front/number/personal/enabled/',
      method: 'post',
      data: obj,
   })
}

/**
 * 取消激活号码
 */
export function disableNumber(obj) {
   return request({
      url: '/tc_api/4front/number/personal/disabled/',
      method: 'post',
      data: obj,
   })
}

/**
 * 值班模式相关接口
 */

/**
 * 设置值班模式
 */
export function setDutyMode(obj) {
   return request({
      url: '/tc_api/4front/duty_mode/set/',
      method: 'post',
      data: obj,
   })
}

/**
 * 获取坐席号码绑定关系
 */
export function getBindings(obj) {
   return request({
      url: '/tc_api/4front/duty_seat_number_binding/get_by_seat_mail/',
      method: 'post',
      data: obj,
   })
}

/**
 * 创建或更新坐席号码绑定关系
 */
export function createOrUpdateBinding(obj) {
   return request({
      url: '/tc_api/4front/duty_numbers/create_or_update/',
      method: 'post',
      data: obj,
   })
}

/**
 * 获取坐席值班排班数据
 */
export function getSchedules(obj) {
   return request({
      url: '/tc_api/4front/duty_schedules/get_by_seat_mail/',
      method: 'post',
      data: obj,
   })
}

/**
 * 获取值班坐席当前生效号码
 */
export function getActiveNumberBySeatMail(obj) {
   return request({
      url: '/tc_api/4front/duty_mode/get_active_number_by_seat_mail/',
      method: 'post',
      data: obj,
   })
}

/**
 * 批量覆盖创建值班排班
 */
export function batchReplaceCreateSchedules(obj) {
   return request({
      url: '/tc_api/4front/duty_schedules/batch_replace_create/',
      method: 'post',
      data: obj,
   })
}

// 新增：单个排班增删改查接口
export function createDutySchedule(data) {
   return request({
      url: '/tc_api/4front/duty_schedules/',
      method: 'post',
      data,
   })
}

export function updateDutySchedule(scheduleId, data) {
   return request({
      url: `/tc_api/4front/duty_schedules/${scheduleId}/`,
      method: 'put',
      data,
   })
}

export function deleteDutySchedule(scheduleId, data) {
   return request({
      url: `/tc_api/4front/duty_schedules/${scheduleId}/`,
      method: 'delete',
      data,
   })
}

export function getDutyScheduleDetail(scheduleId) {
   return request({
      url: `/tc_api/4front/duty_schedules/${scheduleId}/`,
      method: 'get',
   })
}

/**
 * 自动轮班规则相关接口
 */

/**
 * 创建轮班规则
 */
export function createRotationRule(obj) {
   return request({
      url: '/tc_api/4front/duty_rotation/rules/create/',
      method: 'post',
      data: obj,
   })
}

/**
 * 更新轮班规则
 */
export function updateRotationRule(obj) {
   return request({
      url: '/tc_api/4front/duty_rotation/rules/update/',
      method: 'post',
      data: obj,
   })
}

/**
 * 删除轮班规则
 */
export function deleteRotationRule(obj) {
   return request({
      url: '/tc_api/4front/duty_rotation/rules/delete/',
      method: 'post',
      data: obj,
   })
}

/**
 * 启用/暂停轮班规则
 */
export function toggleRotationRule(obj) {
   return request({
      url: '/tc_api/4front/duty_rotation/rules/toggle/',
      method: 'post',
      data: obj,
   })
}

/**
 * 临时换号
 */
export function tempReplaceNumber(obj) {
   return request({
      url: '/tc_api/4front/duty_rotation/temp_replace/',
      method: 'post',
      data: obj,
   })
}

/**
 * 恢复自动轮班
 */
export function restoreAutoRotation(obj) {
   return request({
      url: '/tc_api/4front/duty_rotation/restore_auto/',
      method: 'post',
      data: obj,
   })
}

/**
 * 查询轮班规则列表
 */
export function getRotationRulesList(obj) {
   return request({
      url: '/tc_api/4front/duty_rotation/rules/list/',
      method: 'post',
      data: obj,
   })
}

/**
 * 查询轮班规则详情
 */
export function getRotationRuleDetail(obj) {
   return request({
      url: '/tc_api/4front/duty_rotation/rules/detail/',
      method: 'post',
      data: obj,
   })
}

/**
 * 查询坐席手机接听配置
 */
export function getMobileAnswerConfig(seatEmail) {
   return request({
      url: `/tc_api/4front/tccc/seat/mobile_answer_config/${seatEmail}/`,
      method: 'get',
   })
}

/**
 * 更新坐席手机接听配置
 */
export function updateMobileAnswerConfig(seatEmail, data) {
   return request({
      url: `/tc_api/4front/tccc/seat/mobile_answer_config/${seatEmail}/`,
      method: 'put',
      data: data,
   })
}
